import { useMutation } from "@tanstack/react-query";
import { AxiosRequestConfig } from "axios";
import axios from "../../../../services/department-viags/config.service";
import { BaseResponse } from "../../../chats/types";

interface RenamePublicFolderSchema {
  key: string;
  newName: string;
}

const BASE_PATH = "/edoc";

const publicFolderApi = {
  rename: async (body: RenamePublicFolderSchema, config?: AxiosRequestConfig) => {
    await axios.post<BaseResponse<unknown>>(`${BASE_PATH}/rename-public-folder`, body, config);
  },
};

const useRenamePublicFolder = () => {
  return useMutation({
    mutationFn: (body: RenamePublicFolderSchema) => publicFolderApi.rename(body),
  });
};

export default useRenamePublicFolder;
